export const collapseIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="none" stroke="currentColor" stroke-width="1.5" d="m3 13 5-5 5 5M3 8l5-5 5 5"/></svg>`,
    name: 'collapse'
};